const production = {
  appTitle: 'Africa Corporate Data | Investment in Africa | Africa Companies',
  appTitleShort: 'AsokoInsight',
  appDescription:
    'The most comprehensive database of African private companies for due diligence and business development',
  appLocale: 'en_US',
  appImage: '/assets/images/asoko-logo-og.png',
  appOgTwitterImage: '/assets/images/asoko-logo-og-square.png',
  appThemeColor: '#000',
  appBgColor: '#ffffff',
  msValidate: '78678D2997E8D70DCAF5A569365DF9D8',
  googleSiteVerification: 'llDcEBQrEl4LRDygkXPkOoUiVxkI87UMQKkrKuLDieY',
  appIcon: 'assets/app-icon.png',
  wpDomain: 'https://cms1.asokoinsight.com/',
  client: 'https://asokoinsight.com/',
  apiDomain: 'https://api.asokoinsight.com',
  cdn: 'https://asokoinsight.com',
  asokoApi: 'https://api.asokoinsight.com',
  asokoPoints: 'https://asoko-points.firebaseapp.com',
  loadDbName: 'asokoLocalDB',
  logoUrl: '/assets/asokologo.png',
  trackingGA: 'UA-48104018-2',
  relicPath: '/assets/relic/production.js',
  releaseStage: 'production',
  ga4Tag: 'G-MYBR0KNHKC',
  googleMapsKey: 'AIzaSyA5lnqZ-bay6gkhCj9S9wNIA50eEWbWfzw',
  ctia2018ID: '',
  workableWidgetId: 52676,
  storyblokToken: 'toEEnFgz9nFrhzc6Ql5i5gtt',
  recaptchaApikey: '6Ld-BgwTAAAAAGLLsBHy_7WdQA9BHAi6R1ZEA4r-',
  recaptchaValidResponse:
    '03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww',
}

const staging = {
  appTitle: 'Africa Corporate Data | Investment in Africa | Africa Companies',
  appTitleShort: 'AsokoInsight',
  appDescription:
    'The most comprehensive database of African private companies for due diligence and business development',
  appLocale: 'en_US',
  appImage: '/assets/images/asoko-logo-og.png',
  appOgTwitterImage: '/assets/images/asoko-logo-og-square.png',
  appThemeColor: '#000',
  appBgColor: '#ffffff',
  msValidate: '78678D2997E8D70DCAF5A569365DF9D8',
  googleSiteVerification: 'llDcEBQrEl4LRDygkXPkOoUiVxkI87UMQKkrKuLDieY',
  appIcon: 'assets/app-icon.png',
  wpDomain: 'https://trainasoko.staging.wpengine.com/',
  client: 'https://staging-www.asokoinsight.com/',
  apiDomain: 'https://staging-v2-api.asokoinsight.com',
  cdn: 'https://staging-www.asokoinsight.com',
  asokoApi: 'https://staging-v2-api.asokoinsight.com',
  asokoPoints: 'https://staging-points.asokoinsight.com',
  loadDbName: 'asokoStagingLocalDB',
  logoUrl: '/assets/asokologo.png',
  trackingGA: 'UA-48104018-4',
  relicPath: '/assets/relic/staging.js',
  releaseStage: 'staging',
  ga4Tag: 'G-DCRZKM27NT',
  googleMapsKey: 'AIzaSyA5lnqZ-bay6gkhCj9S9wNIA50eEWbWfzw',
  ctia2018ID: '5a554b9434db77500a9c1161',
  workableWidgetId: 52676,
  storyblokToken: 'toEEnFgz9nFrhzc6Ql5i5gtt',
  recaptchaApikey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  recaptchaValidResponse:
    '03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww',
}

const development = {
  appTitle: 'Africa Corporate Data | Investment in Africa | Africa Companies',
  appTitleShort: 'AsokoInsight',
  appDescription:
    'The most comprehensive database of African private companies for due diligence and business development',
  appLocale: 'en_US',
  appImage: '/assets/images/asoko-logo-og.png',
  appOgTwitterImage: '/assets/images/asoko-logo-og-square.png',
  appThemeColor: '#000',
  appBgColor: '#ffffff',
  msValidate: '78678D2997E8D70DCAF5A569365DF9D8',
  googleSiteVerification: 'llDcEBQrEl4LRDygkXPkOoUiVxkI87UMQKkrKuLDieY',
  appIcon: 'assets/app-icon.png',
  wpDomain: 'http://devasoko/',
  client: 'http://localhost:3000/',
  apiDomain: 'http://localhost:7011',
  cdn: 'http://dev-www.devasoko',
  asokoApi: 'https://staging-v2-api.asokoinsight.com',
  asokoPoints: 'https://staging-v2-api.asokoinsight.com',
  loadDbName: 'asokoDevLocalDB',
  logoUrl: '/assets/asokologo.png',
  trackingGA: 'UA-48104018-5',
  relicPath: './assets/relic/staging.js',
  releaseStage: 'development',
  ga4Tag: 'G-DCRZKM27NT',
  googleMapsKey: 'AIzaSyBAL5N58COxZ-8OXqpcqO7tRhvTGf2bGpM',
  ctia2018ID: '5a5548644f024ee8f56fc57e',
  workableWidgetId: 52676,
  storyblokToken: 'toEEnFgz9nFrhzc6Ql5i5gtt',
  recaptchaApikey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  recaptchaValidResponse:
    '03AHJ_VuulQ3Vhnk24UfCfPtOigxVqHWsNjYJI_kn3cSmHC87et17zUa0xhOHyYlLQ3AeN0II2RH5LexR5yztGatPI0LUrg_JaBn4cOOGmxGc31La8aLBHVmD80XVLMA0lNZ-IwzQ8CJaiC6cdAwYzWbNiqDZ4eYy4HDgZlEe1SKnOIA7pC3qXWckTqnXc5XS--Nd5KuVXuUF6F2wROKcScu7qrH66Ci4ih9i3WoYuF7H9_Q2rLUcfUYNtJG-rs9hQBWLK1TXWNMnnVizSfvcgk7jR3lXLbFwRAMdgHt6WcvgLGmz5b5QNaZRb6q6_WoqMzeeoF4ez-BLlu5VmXsGnqut2CRBT8blDaO-vIL5tw8pAqjQ-_yhZC2uf0IUq1dLrnT23X8uONxXdW2rfo4R8Ei7OADxvDbbsYRMCkflEyGzmiBla-Dy5pOD17ShgS2pl5BFjupkorOLNt0CL1kKoyI0l3uu-NkQ5ryzs8jotIPYUySFyeSyByAlJ61Tz4JwWHxWDtiP-2wbsnCHI1IPvgQ8eYO3whHBqmi_FYJwXc1gj0S3B2SUn5gETwBH4GYLt20qKCWX5W7p8OilTmyioTzEPY-mZtrGYFyun8TntpqJtMtDUhEzQ8O5rhEf5oFrL66_xbx11fgXiUhQFjUJ-sRZRGXCUjgSejZKBfbQxBzlVuQcdJKYlr87_fs99yFCmgKZ0qVyMo66l9EraofELvNveXVI66rsF_1661UU5ohxb7GRH7v3k9k_hqL7ynJa8F8NePSuFcpwLOcQQy3Bzi5WQ-c5ExnEAyhAgtCFyqKwcU8pxbf0WkUYdYJ8MePg8hrmGptPG6ZcrQd-oQbGxoH-B_U62kD0txxcPACitrDHM4Jou0kWBeNkWs46V6GsTnoJ_x29X947yJ7vTBFnQFsNE-dUFtQv_Ww',
}

const configs = {
  development,
  production,
  staging,
}

const getConfig = () => {
  const env = process.env.TARGET_ENV || 'development'
  return configs[env]
}

module.exports = getConfig()
